const CenterLayout = ({ children }: { children: JSX.Element }) => {
  return (
    <div className="flex h-viewarea">
      <div className="m-auto">{children}</div>
    </div>
  );
};

export default CenterLayout;
